

<ul class="products-wrapper grid-wrapper row" id="product-grp">
    
    <ng-container *ngIf="products.length === 0">
        <div class="empty-products h-small">
            <span>상품을 업데이트중입니다. 나중에 다시 오시기 바랍니다.</span>
        </div>
    </ng-container>
    
    <ng-container *ngFor="let item of products | paginate: config; index as i">
        <li class="product">
            <div class="featured-wrapper" style="width: 100%;">
            <a href="javascript:;" (click)="handleOnClickProductDetail(item);" >
                <div class="img-wrapper">
                    <ng-container *ngIf="item.fileName === null || item.fileName === ''">
                        <img src="./assets/img/noImage.jpg">
                    </ng-container>
                    <ng-container *ngIf="item.fileName !== null && item.fileName !== ''">
                        <img  [ngClass]="item.fileNameHover !== null?'main-img':''" [src]="urlWownet + item.filePath + item.fileName">
                    </ng-container>
                    <ng-container *ngIf="item.fileNameHover !== null && item.fileNameHover !== ''">
                        <img class="hover-img" [src]="urlWownet + item.filePathHover + item.fileNameHover">
                    </ng-container>
                </div>
            </a>
            <ng-container *ngIf="item.linkInfo !== null && item.linkInfo !== ''">
                <div style="padding-left: 20px" [innerHTML]="(item.linkInfo | playYoutubeFrame:i)"></div>
            </ng-container>
            </div>
            <div class="product-content text-center">
                <a href="javasrcipt:;" class="name-id" (click)="handleOnClickProductDetail(item);">
                    <h4 class="name h-false">{{ item.pdtName }}</h4>
                    <!-- <span class="id">{{ item.pdtCD }}</span> -->
                    <div class="tags">
                        <ng-template
                            *ngIf="item.newSDate && item.newSDate <= today && (!item.newEDate || item.newEDate >= today)">
                            <span class="tag">{{ 'shopping-mall.home.lbl.02' | translate }}</span>
                        </ng-template>
                    </div>
                </a>                
                <div class="price h-false">
                    <ng-container *ngIf="isLogined">
                        <ng-container>
                            <div class="row prices">
                                <div class="type member">
                                    <span>{{ 'currency' | translate: { param: item.retailAmt | cusprice: item.amt | setComma:'price':'' } }}</span>
                                </div>
                            </div>
                        </ng-container>
                        <div class="row pvs justify-content-center" *ngIf="userKind != '00'">
                            <div class="col-auto type pv" *ngIf="isPv1">
                                <span class="currency">{{ smWowWord.oPv1 }}</span>
                                <span class="value">{{ item.pv1 | setComma:'':'' }}</span>
                                
                            </div>
                            <div class="col-auto type pv" *ngIf="isPv2">
                                <span class="currency">{{ smWowWord.oPv2 }}</span>
                                <span class="value">{{ item.pv2 | setComma:'':'' }}</span>
                                
                            </div>
                            <div class="col-auto type pv" *ngIf="isPv3">
                                <span class="currency">{{ smWowWord.oPv3 }}</span>
                                <span class="value">{{ item.pv3 | setComma:'':'' }}</span>
                                
                            </div>
                            <div class="col-auto type pv" *ngIf="isPoint">
                                <span class="currency">{{ smWowWord.oMileage }}</span>
                                <span class="value">{{ item.point | setComma:'':'' }}</span>                                    
                            </div>
                        </div>                                                   
                    </ng-container>


                    <ng-container *ngIf="!isLogined">
                        <div class="row prices">
                            <div class="type regular" *ngIf="isRetailAmt">
                                <span>{{ 'currency' | translate: { param: item.retailAmt | setComma: 'price':'' } }}</span>
                            </div>
                        </div>
                        <div class="row pvs">
                            <ng-container *ngIf="isAmt">
                                <div class="col-auto type member">
                                    <span>{{ 'currency' | translate: { param: item.amt | setComma: 'price':'' } }}</span>
                                </div>
                                <div class="col-auto type pv" *ngIf="isPv1">
                                    <span class="value">{{ item.pv1 | setComma:'':'' }}</span>
                                    <span class="currency">{{ smWowWord.oPv1 }}</span>
                                </div>
                                <div class="col-auto type pv" *ngIf="isPv2">
                                    <span class="value">{{ item.pv2 | setComma:'':'' }}</span>
                                    <span class="currency">{{ smWowWord.oPv2 }}</span>
                                </div>
                                <div class="col-auto type pv" *ngIf="isPv3">
                                    <span class="value">{{ item.pv3 | setComma:'':'' }}</span>
                                    <span class="currency">{{ smWowWord.oPv3 }}</span>
                                </div>
                            </ng-container>
                            <div class="col-auto type pv" *ngIf="isPoint">
                                <span class="value">{{ item.retailPoint | setComma:'':'' }}</span>
                                <span class="currency">{{ smWowWord.oMileage }}</span>
                            </div>
                        </div>  
                        
                    </ng-container>
                </div>  
                <div class="function row  justify-content-center">
                    <div class="col-auto quantity-input row">
                        <div class="quantity-tit col-auto">주문수량
                        </div>
                        <div class="cal-btn minus col-auto" (click)="handleOnChangeQuanity(i, minus);" [ngClass]="{'disable-btn': item.saleMaxQty == 0 && item.saleMinQty == 0}">
                            <img src="./assets/img/icons/quantity-minus.svg">
                        </div>
                        <div class="value col-auto">
                            <span id="qty">{{ quantities[i] | setComma:'':'' }}</span>
                        </div>
                        <div class="cal-btn plus col-auto" (click)="handleOnChangeQuanity(i, plus);" [ngClass]="{'disable-btn': item.saleMaxQty == 0 && item.saleMinQty == 0}">
                            <img src="./assets/img/icons/quantity-plus.svg">
                        </div>
                    </div>
                </div>              
            </div>
            <!-- <div class="simple-btn-wrapper">
                <div class="simple-btn h-false" (click)="handleOnClickProductDetail(item);">
                    <span>{{ 'shopping-mall.home.lbl.031' | translate }}</span>
                    <svg width="26" height="10" viewBox="0 0 26 10" fill="none">
                        <path d="M0 5H25" stroke="#2A2E46" />
                        <path d="M21 9L25 5L21 1" stroke="#2A2E46" stroke-miterlimit="10" />
                    </svg>
                </div>
            </div> -->
            
            <div class="w-btn outline-btn add-btn" (click)="handleOnAddToCart(i);" [ngClass]="{'disable-btn': item.saleMaxQty == 0 && item.saleMinQty == 0}">
                <span>장바구니 담기</span>
            </div>
            
        </li>
    </ng-container>
</ul>